import { FC, useState } from 'react';
import { WidgetsData } from '../../WidgetRow';
import Lightbox, { SlideImage } from 'yet-another-react-lightbox';
import { getFragmentData, graphql } from '../../../../../gql';
import { SimplePictureGrid } from './SimplePictureGrid';
import { alpha, useTheme } from '@mui/material';
import { getNightOrDayPalette } from '../../../../../utils/getNightOrDayPalette';

const pictureGridFragment = graphql(`
	fragment PictureGrid_Gallery on Activity {
		galleryImgSource: pictures {
			id
			order
			image {
				url(width: 450)
			}
		}
	}
`);

type Props = Readonly<{
	widget: WidgetsData;
}>;

export const PictureGrid: FC<Props> = ({ widget }) => {
	const [photoIndex, setPhotoIndex] = useState(-1);
	const { pictures: unsortedPictures } = widget;
	const { galleryImgSource } = getFragmentData(pictureGridFragment, widget);
	const theme = useTheme();

	const slideImages: SlideImage[] = galleryImgSource.map((galleryImage) => ({
		src: galleryImage.image?.url ?? '',
	}));

	const pictures = [...unsortedPictures].sort((a, b) => a.order - b.order);

	return (
		<>
			<SimplePictureGrid pictures={pictures} handlePictureClick={setPhotoIndex} />
			<Lightbox
				styles={{
					root: {
						'--yarl__color_backdrop': alpha(theme.palette[getNightOrDayPalette(theme)][50] ?? '#000', 0.7),
						'--yarl__button_filter': 'none',
						'--yarl__color_button': theme.palette[getNightOrDayPalette(theme)][700] as string,
						'--yarl__color_button_active': theme.palette[getNightOrDayPalette(theme)][600] as string,
					},
				}}
				index={photoIndex}
				slides={slideImages}
				open={photoIndex >= 0}
				close={() => setPhotoIndex(-1)}
			/>
		</>
	);
};
